import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { endpoint } from '../utils';
import { setLoading } from '../redux/actions/loader.action';

export default function ForgotPasswordPage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const { me } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setError(null);
    setSuccess(null);
    await axios.post(`${ endpoint }api/auth/forgot-password`, {email}, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(({ data }) => {
                setEmail("");
                setIsEmailTouched(false);
                setSuccess("Vous avez reçu un email pour récupérer vote compte.");
              })
              .catch((err) => {
                setError(err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message);
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }

  useEffect(() => {
    if(jwt_access){
      navigate('/');
    }
  }, [location, navigate, jwt_access]);

  return (
    !me &&
    <HelmetProvider>
      <Helmet>
        <title>Mot de passe oublié ? - Société Mikalo</title>
      </Helmet>

      <div id="authLogin">
        <form className='form login-form' onSubmit={ handleSubmit }>
          <div className='login-form-logo'>
            <img src="/images/logo.png" alt="" />
          </div>

          <div className='title'>
            <h1>Mot de passe oublié ?</h1>
          </div>
          { error && <div className='alert alert-danger'>{ error }</div> }
          { success && <div className='alert alert-success'>{ success }</div> }
          <div className='mb-3'>
            <label htmlFor='email' className='required'>E-mail</label>
            <input type='email' id='email' name='email' value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } className='form-control' placeholder='E-mail' required autoComplete='off' />
            { isEmailTouched && email.length === 0 && <div className='form-error'>Veuillez saisir votre e-mail.</div> }
            { isEmailTouched && email.length > 0 && /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>Votre e-mail n'est pas valide.</div> }
          </div>
          <div className='pt-1 mb-3'>
              <button type='submit' className='btn btn-primary w-100 btn-lg' disabled={
                /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false
              }>M'envoyer un mail</button>
          </div>
          <div className='text-center'>
            <Link to="/login">Se connecter</Link>
          </div>
        </form>
      </div>
    </HelmetProvider>
  )
}
